import { useAuth0 } from './auth0'
import { isLocal } from '../utils/helpers'

export const useHasRight = (action) => {
    const { profile } = useAuth0()
    const context = isLocal ? 'https://mmg/user_metadata' : 'https://mmg/user_metadata'
    const userActions = profile ? profile[context].actions : []
    const hasRight = userActions ? userActions.find(a => a === action) : null
    return hasRight != null
}